$('input[type="number"]').each(function(){
	var input = this;
	var $wrap = $('<span class="input-number-wrapper"></span>');
	var $dec = $('<span class="input-number-dec">-</span>');
	var $inc = $('<span class="input-number-inc">+</span>');

	$(input).wrap($wrap);
	$(input).before($dec);
	$(input).after($inc);

	$inc.on('click',function(e){
		$dec.removeClass('disable');
		var v = parseInt($(input).val())+1;
		var max = $(input).attr('max');
		if(v > max )
		{
			v = max;
			$(this).addClass('disable');
		}
		$(input).val(v);
	});

	$dec.on('click',function(e){
		$inc.removeClass('disable');
		var v = parseInt($(input).val())-1;
		var min = $(input).attr('min');
		if(v < min )
		{
			v = min;
			$(this).addClass('disable');
		}
		$(input).val(v);
	});
});